export function resolveTrigger(trigger) {
  return null
}